module.exports = __webpack_public_path__ + "img/_Large-Semi-Elliptical-Attachment-R.20dd12b1.jpg";